<router-outlet></router-outlet>
@if (notificationService.showNotification()) {
    <ng-notification
        [title]="notificationService.notification().title"
        [message]="notificationService.notification().message"
        [type]="notificationService.notification().type"
        [icon]="notificationService.notification().icon"
        class="fixed right-4 top-4 z-20 block"
    ></ng-notification>
}
